<div class="ui-products">
    <div class="ui-products-header" *ngIf="productsInitStatus">
        <div class="ui-products-header-container">
            <div class="ui-products-header-title">
                <h1>Historial de productos</h1>
            </div>

            <button mat-flat-button color="primary" class="ui-button" (click)="onAdd()">Contratar plan</button>   
        </div>
    </div>
    
    <div class="ui-products-list" *ngIf="productsInitStatus">
        <div class="ui-products-list-container">
            <div class="ui-bar-filters">
                <div class="el-left-filters">
                    
                </div>

                <div class="el-right-filters">
                    <!--<button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterStatus">Estado <mat-icon>expand_more</mat-icon></button>

                    <mat-menu #filterStatus="matMenu">
                        <button mat-menu-item>Todo</button>
                        <button mat-menu-item>Conectado</button>
                        <button mat-menu-item>Anulado</button>
                        <button mat-menu-item>Desconectado</button>
                    </mat-menu>-->
                    
                    <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterExport">Exportar listado <mat-icon>expand_more</mat-icon></button>
    
                    <mat-menu #filterExport="matMenu">
                        <button mat-menu-item (click)="onExport('xls')">Microsoft Excel (xlsx)</button>
                        <button mat-menu-item (click)="onExport('cvs')">CVS separado por coma (cvs)</button>
                        <button mat-menu-item (click)="onExport('json')">Archivo JSON (json)</button>
                    </mat-menu>
                </div>
            </div>
            
            <div class="ui-shadow"style="position:relative;">
                <div class="ui-spinner-container" *ngIf="productsUpdating">
                    <mat-spinner class="ui-spinner" [diameter]="25"></mat-spinner>
                </div>

                <div class="product" *ngIf="products.length <= 0"><div class="product-empty">No existen productos para mostrar</div></div>

                <div class="product" *ngFor="let product of products; last as last">
                    <div class="product-status">
                        <mat-icon [matTooltip]="productsStatus(product.status)" [ngClass]="{'canceled': product.status == 'Anulado', 'disconnected': product.status == 'Desconectado', 'connected': product.status == 'Conectado'}">lens</mat-icon>
                    </div>

                    <div class="product-data">
                        <div class="product-title">{{product.product.name}}</div>
                        <div class="product-details">
                            <span class="product-status-ref" [ngClass]="{'canceled': product.status == 'Anulado', 'disconnected': product.status == 'Desconectado', 'connected': product.status == 'Conectado'}">{{productsStatus(product.status)}}</span>
                            <span class="product-number">Contrato número: {{product.id}}</span>
                        </div>
                    </div>

                    <div class="product-options">
                        <button mat-icon-button (click)="onEdit(product)" *ngIf="product.isReplaceable" matTooltip="Modificar mi producto">
                            <mat-icon>create</mat-icon>
                        </button>
                        <button mat-icon-button (click)="onDelete(product)" *ngIf="product.isRemovable" matTooltip="Solicitar baja">
                            <mat-icon>highlight_off</mat-icon>
                        </button>
                    </div>
                </div>

                <mat-paginator *ngIf="products.length > 0" [length]="productsTotal" [pageSize]="productsPageSize" [pageSizeOptions]="[5, 10, 25, 50]" (page)="onPaginationChange($event)"></mat-paginator>
            </div>
        </div>
    </div>    

    <ui-screen-loader *ngIf="!productsInitStatus"></ui-screen-loader>
</div>